<template>
  <div elevation-1 class="container-tile" >
    <h3>{{ title }}</h3>
    <div pa-1 class="container-tile-content">
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: 'tile',
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
  }),
  methods: {
  },
};
</script>

<style scoped>
.container-tile {
  border-style: solid;
  border-width: 1px;
  border-color: transparent;
  height: 100%;
}
.container-tile-content {
  height: 100%;
}
</style>
